/**
 * Exception Handler 의 종류 구분
 * @since 0.0.1
 * @author Heungsoo Ham
 * @enum
 */
export enum ExceptionType {
    ALERT = "Alert",
    WARNING = "Warning",
    ERROR = "Error",
    INFO = "Info",
    EXCEPTION = "Exception"
}

/**
 *  message
 * @since 0.0.1
 * @author Heungsoo Ham
 * @interface
 */
export interface ToastMessage {
    summary?: string;
    message?: string;
}

/**
 * Helper 내 인스턴스는 core 가 생기기전 생성.
 * Helper 에서 Core 의 ExceptionHandler 에 접근하기 위한 이름
 * @since 0.0.1
 * @author Heungsoo Ham
 */
export const  BizFormCoreExceptionHandler = "'___ExceptionHandler";
